export const CONTENT_SCHEMA = {
  hero: {
    label: "Hero",
    fields: [
      { key: "image", label: "Hero banner image — replaces the entire banner graphic (use ~1958×803 px). A single black 'Connect with your HP Poly specialist' button is overlaid automatically.", type: "image" },
    ],
  },
  countdown: {
    label: "Countdown Timer",
    fields: [
      { key: "items", label: "Milestones — Label | Date (YYYY-MM-DD), one per row", type: "objects", fields: ["label", "date"] },
    ],
  },
  banner: {
    label: "Benefits Banner",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "paragraph", label: "Paragraph", type: "textarea" },
      { key: "chips", label: "Benefit chips (one per row)", type: "lines" },
      { key: "ctaText", label: "Link text", type: "text" },
      { key: "image", label: "Banner photo URL", type: "image" },
    ],
  },
  marquee: {
    label: "Marquee Ribbon",
    fields: [{ key: "items", label: "Ribbon items (one per row)", type: "lines" }],
  },
  whyMove: {
    label: "Why Move to Gen 2",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "textarea" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "benefits", label: "Benefits (one per row)", type: "lines" },
    ],
  },
  videoos: {
    label: "VideoOS 5.0 Foundation",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "cards", label: "Cards — Title | Description, one per row", type: "objects", fields: ["title", "desc"] },
    ],
  },
  upgradeBanner: {
    label: "Upgrade Now Banner",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Headline", type: "textarea" },
      { key: "lead", label: "Paragraph", type: "textarea" },
      { key: "deadlines", label: "Deadline chips (one per row)", type: "lines" },
      { key: "ctaText", label: "Button text", type: "text" },
    ],
  },
  whatsBetter: {
    label: "What's Better (Pillars)",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "pillars", label: "Pillars — Title | Description | point1; point2; …, one per row", type: "objects", fields: ["title", "desc", "points"] },
    ],
  },
  specTables: {
    label: "Spec Tables (Tabs)",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
    ],
  },
  longTerm: {
    label: "Built for the Long Term",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "supportLabel", label: "Support banner label", type: "text" },
      { key: "supportText", label: "Support banner text", type: "textarea" },
      { key: "timeline", label: "Timeline — Year | Label, one per row", type: "objects", fields: ["year", "label"] },
      { key: "items", label: "Cards — Title | Description, one per row", type: "objects", fields: ["title", "desc"] },
    ],
  },
  milestones: {
    label: "Platform Milestones",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "tableTitle", label: "Table title", type: "text" },
      { key: "rows", label: "Table rows — Platform | Milestone | Urgency (High/Medium), one per row", type: "objects", fields: ["platform", "milestone", "urgency"] },
      { key: "planTitle", label: "Planning strip title", type: "text" },
      { key: "planLead", label: "Planning strip text", type: "textarea" },
      { key: "actions", label: "Planning actions (one per row)", type: "lines" },
    ],
  },
  matrix: {
    label: "Replacement Matrix",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "mappings", label: "Mappings — Gen 1 device | Gen 2 device | Benefit, one per row", type: "objects", fields: ["gen1", "gen2", "benefit"] },
    ],
  },
  steps: {
    label: "5-Step Migration Plan",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "steps", label: "Steps — Name | Description, one per row", type: "objects", fields: ["name", "desc"] },
    ],
  },
  rooms: {
    label: "Room Solutions",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "rooms", label: "Room cards", type: "roomCards" },
    ],
  },
  leadForm: {
    label: "Contact Form Section",
    fields: [
      { key: "eyebrow", label: "Eyebrow line", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "lead", label: "Intro paragraph", type: "textarea" },
      { key: "checklist", label: "Checklist items (one per row)", type: "lines" },
      { key: "note", label: "Side note", type: "textarea" },
      { key: "formTitle", label: "Form title", type: "text" },
      { key: "formSub", label: "Form subtitle", type: "text" },
      { key: "submitLabel", label: "Submit button text", type: "text" },
      { key: "successTitle", label: "Success message title", type: "text" },
      { key: "successBody", label: "Success message body ({name} and {email} are replaced)", type: "textarea" },
    ],
  },
};
